import axios from '@axios';
import { useStore } from '@/store';
import { StickerType, TtsDisplayMode } from '@/utils/constants';

class StickersTabStreamerStatus {
	// StickersTabData object.
	uiData;

	// Vuex store.
	store;

	constructor(uiData) {
		this.uiData = uiData;
		this.store = useStore();
	}

	// Checks if the streamer is online and also if the config has changed.
	// The sticker param is optional and is used for TTS stickers to ensure the co-host browser source is live.
	checkStatus(onComplete, sticker) {
		const result = {
			doReloadServerData: false,
			partyModeStatus: {
				isEnabled: false,
				isActive: false,
				timeLeft: 0,
			},
		};

		// Append the sticker id only if it's a TTS co-host sticker.
		let url = '/streamer-status';
		const isTtsCoHostSticker =
			sticker && sticker.stickerType == StickerType.TTS && sticker.tts.displayMode == TtsDisplayMode.CO_HOST;
		if (isTtsCoHostSticker) {
			url += `?stickerId=${sticker.id}`;
		}

		axios
			.get(url)
			.then(res => {
				if (res.status === 200) {
					// Check maintenance mode and streamer online.
					const isMaintenanceMode = res.data.isMaintenanceMode;

					// See if the config hash or global timestamp changed.
					// If so, remove local data and reload the panel.
					if (!isMaintenanceMode) {
						let isLocalValid = false;
						const localData = this.uiData.getLocalData();
						if (localData && localData.configHash && localData.globalTs) {
							if (
								localData.configHash == res.data.configHash &&
								localData.globalTs == res.data.globalTs
							) {
								isLocalValid = true;
							}
						}

						if (!isLocalValid) {
							this.uiData.removeLocalData();
							result.doReloadServerData = true;
							//console.log('Local cache is invalid. Will reload data from server.');
						} else {
							// Set streamer status for main browser source.
							let isStreamerOnline = res.data.isOnline;

							// If we are checking a specific co-host sticker, check if the co-host browser source is live.
							if (isTtsCoHostSticker && !res.data.isTtsCoHostSlotActive) {
								isStreamerOnline = false;
							}

							this.store.commit('setExtensionOnline', !isMaintenanceMode);
							this.store.commit('setStreamerOnline', isStreamerOnline);
						}
					}

					// Set party mode status.
					result.partyModeStatus = res.data.partyModeStatus;
					this.store.commit('setIsPartyModeOn', result.partyModeStatus.isActive);
				} else {
					this.store.commit('setExtensionOnline', false);
				}
			})
			.catch(() => {
				this.store.commit('setExtensionOnline', false);
			})
			.finally(() => {
				if (onComplete) {
					onComplete(result);
				}
			});
	}

	scheduleStatusCheck(onComplete) {
		setTimeout(() => {
			this.checkStatus(onComplete);
		}, 5000);
	}
}

export { StickersTabStreamerStatus };
